import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {saveAs} from "file-saver";

@Component({
  selector: 'app-license-key-copyable',
  templateUrl: './license-key-copyable.component.html',
  styleUrls: ['./license-key-copyable.component.scss'],
})
export class LicenseKeyCopyableComponent implements OnInit {
  @Input() licenseKey: string;
  @Input() offlineLicenseKey: string;
  @Input() showOfflineLicenseKey: boolean = true;
  @Input() showRenewOfflineLicenseKeyButton: boolean = true
  @Output() onRenewOfflineLicenseKey = new EventEmitter<void>();

  copied: boolean = false;

  ngOnInit() {
    if (!this.offlineLicenseKey) {
      throw new Error('Offline license key is required.');
    }
  }

  onCopy() {
    if (this.copied) return;
    this.copied = true;
    navigator.clipboard.writeText(this.offlineLicenseKey);
    setTimeout(() => (this.copied = false), 5000);
  }

  downloadLicenseFile() {
    const blob = new Blob([this.offlineLicenseKey], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, this.licenseKey);
  }

  renewOfflineLicenseKey() {
    this.onRenewOfflineLicenseKey.emit();
  }
}
